import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit {


  public icon_name:string = '';

  public data :any = JSON.parse(window.atob(window.location.href.split("/").pop()));
  constructor() { }

  ngOnInit(): void {
  }

}
